import SignupForm from '../components/signup_form/SignupForm';

const Signup = () => {
   return <SignupForm />;
};

export default Signup;
